import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';

type SetStateCallback<S> = ((prevState: S) => S);

interface Props {
    value: number;
    setValue: React.Dispatch<SetStateCallback<number>>;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    actingBodyId: number;
}

export default function HandcuffReasonDropdown({ value, setValue, zIndex, disabled, labelFontSize, label, actingBodyId }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const { user: authenticatedUser } = useAuth();

    async function getHandcuffReasons() {
        try {
            const actingBody = getActingBodyId();
            if (actingBody === 0) {
                setItems([]);
                return;
            }
            const response = await dispatchService.getHandcuffReasons(actingBody);
            setItems(response.map(unitProgram => ({
                label: unitProgram.name, value: unitProgram.id!
            })));
        } catch (err) {
            console.error(err);
        }
    }

    function getActingBodyId() {
        if (!authenticatedUser || !authenticatedUser.actingBodyUnit.actingBodyId) {
            return 0;
        }

        if (authenticatedUser.isAdmin) {
            return actingBodyId;
        } else {
            return authenticatedUser.actingBodyUnit.actingBodyId;
        }
    }

    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }
        getHandcuffReasons();
    }, [actingBodyId, authenticatedUser]);

    return (
        <FilterDropdown
            label={label ?? translate('handcuffReason')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
        />
    );
}
